var e={rcsSimpleStepper:"rcsSimpleStepper--Y2WP7"};export{e as default};
//# sourceMappingURL=SimpleStepper.module.scss.js.map
